import {
  NgIf,
  NgForOf,
  NgOptimizedImage,
  isPlatformBrowser
} from '@angular/common';
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppSettings } from '@Shared/app.settings';
import { LandingPageService } from '@App/pages/landing-page/landing-page.service';
import { AuthService } from '@App/pages/auth/services';
import { AuthActionType } from '@App/pages/auth/auth.type';
import { UserCommonApiService } from '@App/common/services';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  imports: [NgIf, NgForOf, RouterLink, NgOptimizedImage]
})
export class FooterComponent implements OnInit, OnDestroy {
  @Input() isHideFooterLinks = false;
  helpCenterLink: string = AppSettings.helpCenterLink;

  $hideLinks: Subscription;
  currentYear: number = new Date().getFullYear();
  socialLinksArray: any[] = [
    {
      url: 'https://www.facebook.com/pitch59social/',
      imageAlt: 'Facebook',
      imageSrc: 'assets/images/facebook-icon-white.svg'
    },
    {
      url: 'https://x.com/pitch59_',
      imageAlt: 'XCom',
      imageSrc: 'assets/images/footer/icon-x.svg'
    },
    {
      url: 'https://www.instagram.com/pitch59_',
      imageAlt: 'Instagram',
      imageSrc: 'assets/images/footer/icon-instagram.svg'
    },
    {
      url: 'https://www.linkedin.com/company/19087630',
      imageAlt: 'LinkedIn',
      imageSrc: 'assets/images/footer/icon-linkedin.svg'
    }
    // {
    //   url: 'https://www.tiktok.com/@pitch5926',
    //   imageAlt: 'TikTok',
    //   imageSrc: 'assets/images/icon-tiktok.png'
    // }
  ];

  rightLinks = [
    { label: 'Contact', url: null, external: false, action: 'contact' },
    { label: 'Privacy Policy', url: '/privacy-policy', external: false },
    { label: 'Terms of Service', url: '/terms-and-conditions', external: false }
  ];

  constructor(
    private router: Router,
    private welcomePageService: LandingPageService,
    private userCommonService: UserCommonApiService,
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}

  ngOnInit() {
    this.$hideLinks = this.userCommonService.hideLinks.subscribe(
      (isSignedIn: boolean) => {
        this.isHideFooterLinks = isSignedIn;
      }
    );
    this.isHideFooterLinks = this.userCommonService.isAuthenticated();
  }

  ngOnDestroy() {
    if (this.$hideLinks) {
      this.$hideLinks.unsubscribe();
    }
  }

  goToPage(link, query?) {
    this.welcomePageService.smoothVerticalScrolling(0, 300);
    setTimeout(() => {
      query
        ? this.router.navigate([link], { queryParams: query })
        : this.router.navigate([link]);
    }, 300);
  }

  handleLinkClick(link) {
    if (link.action === 'contact') {
      // Open contact support popup instead of navigating to URL
      this.userCommonService.openSupportWindow(1); // 1 for Contact Support
    } else if (link.external) {
      if (isPlatformBrowser(this.platformId)) {
        window.open(link.url, '_blank');
      }
    } else {
      this.goToPage(link.url);
    }
  }

  auth(type: AuthActionType) {
    this.authService.setAction(type);
  }
}
